<template lang="pug">
v-list(class="print-bg")
    div(:id="ip._id")
        .page(size="Auto")
            div(class="view-width" style="font-size:11px;")
                table( class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                  tbody
                      tr
                          td(
                            class="headerTable" 
                            colspan="10"
                          ) 
                            span(v-if="ip.ipTingkatRisikoSetelahPerubahan.tingkatRisiko > 4") G.
                            span(v-else) F.
                            | &nbsp;Pengesahan
                table(class="view-width tableCollapse tableInput")
                  tbody
                      tr
                          td(class="headerTable align-center" width="25%") Nama
                          td(class="headerTable align-center" width="20%") Jabatan
                          td(class="headerTable align-center" width="20%") Tanggal
                          td(class="headerTable align-center" width="15%") Tanda Tangan
                          td(class="headerTable align-center"  width="20%") Catatan
                      tr(v-for="(item, index) in ip.ipWorkflow" :key="index")
                          td 
                            div( class="approved") {{ item.admin_reject == true ? item.admin_detail.name : item.name }}
                          td 
                            div( class="approved") {{ item.admin_reject == true ? 'Admin' : item.title }} {{ (item.title == undefined) ? jabatanDetail(item.postAs, index, ip.ipForm) : '' }}
                          td 
                            div(v-if="item.status == 7" class="approved")
                              br
                              | {{approvalTime(item.date)}}
                              br
                            div(v-else-if="item.status == 8" class="approved")
                              br
                              | {{approvalTime(item.date)}}
                              br
                            div(v-else class="emptySign")
                          td 
                            div(v-if="item.status == 7" class="approved")
                                img(src="../assets/check-64.png" style="width:25px;")
                            div(v-else-if="item.status == 8" class="approved")
                                img(src="../assets/close-64.png" style="width:25px;")
                            div(v-else class="emptySign")
                          td 
                            p(v-if="item.comment || ''" class="align-left top-align comment") {{ item.comment }}
                            div(v-else class="emptySign")


                table(class="view-width tableInput autoPageBreak" style="margin-top:10px;" v-if="ip.ipPengesahan")
                  tbody
                      tr
                          td(
                            class="headerTable" 
                            colspan="10"
                          )
                            span(v-if="ip.ipTingkatRisikoSetelahPerubahan.tingkatRisiko > 4") H.
                            span(v-else) G.
                            | &nbsp;Penyelesaian Pekerjaan
                table(class="view-width tableCollapse tableInput" v-if="ip.ipPengesahan")
                  tbody
                      tr
                          td(class="headerTable align-center" width="25%") Nama
                          td(class="headerTable align-center" width="20%") Jabatan
                          td(class="headerTable align-center" width="20%") Tanggal
                          td(class="headerTable align-center" width="15%") Tanda Tangan
                          td(class="headerTable align-center"  width="20%") Catatan
                      tr(v-for="(item, index) in ip.ipPengesahan.ipWorkflow" :key="index")
                          td 
                            div( class="approved") {{ item.admin_reject == true ? item.admin_detail.name : item.name }}
                          td 
                            div( class="approved") {{ item.admin_reject == true ? 'Admin' : item.title }} {{ (item.title == undefined) ? jabatanDetail(item.postAs, index, ip.ipForm) : '' }}
                          td 
                            div(v-if="item.status == 7" class="approved")
                              br
                              | {{approvalTime(item.date)}}
                              br
                            div(v-else-if="item.status == 8" class="approved")
                              br
                              | {{approvalTime(item.date)}}
                              br
                            div(v-else class="emptySign")
                          td 
                            div(v-if="item.status == 7" class="approved")
                                img(src="../assets/check-64.png" style="width:25px;")
                            div(v-else-if="item.status == 8" class="approved")
                                img(src="../assets/close-64.png" style="width:25px;")
                            div(v-else class="emptySign")
                          td 
                            p(v-if="item.comment || ''" class="align-left top-align comment") {{ item.comment }}
                            div(v-else class="emptySign")

                table(
                  class="view-width tableInput autoPageBreak" 
                  style="margin-top:10px;" 
                  v-if="ip.ipTingkatRisikoSetelahPerubahan.tingkatRisiko <= 4"
                )
                  tbody
                      tr
                          td(class="headerTable" width="150" colspan="8") Deskripsi Penyelesaian Pekerjaan
                      tr
                          td 
                              div(v-if="ip.ipDeskripsiPenyelesaian" v-html="ip.ipDeskripsiPenyelesaian" class="ck-content")   
                              div(v-else class="ck-content")  
                                p 
</template>

<script>

import * as config from "../config/index.json";
import helper from "../helper/index.js";
import { mapState } from 'vuex';
import printJS from 'print-js';
export default {
  name: 'UsulanthirdView',
  components: {
  },
  props: {
    dialogType: String,
    ip: Object,
    approvalUser: Object
  },
  mounted() {
    
  },
  data: () => ({
    formName: config.FormName,
    dialog: false,
    regex: /\//gi,
    approvalDialog: false,
    approvalDialog2: false,
    comment: '',
    approval: null,
    share: false,
    print: false,
  }),
  computed: {
    ...mapState(['API_URL', "networks", "sharing", "shortenUrl", "dataUsers"]),
    locations(){
        let temp = []
        for (const index in this.ip.ipLocation) {
            temp.push(this.ip.ipLocation[index].name)
        }
        return temp
    },
  },
  methods: {
    jabatanDetail: helper.jabatanDetail,
    download(file) {
        this.$downloadFile(file);
    },
    shareIP() {
        this.$store.dispatch("getShortenUrl", {ip: this.ip, 
        approvalUser: this.approvalUser, context: this.share}).then(() => {
            this.share = true;
        });
    },
    printIP(id){
        printJS({
            printable: id, 
            type: 'html',
            scanStyles: false,
            css: ["/stylesheets/main.css" ,"/stylesheets/approval.css", "/stylesheets/vuetify.min.css", '/stylesheets/view.css', "/stylesheets/ck-content.css"]
        });
    },
    formatDate: helper.formatDateOnly,
    getApproveStatus(wf){
        let status = 0;
        for(let i=0;i<wf.length;i++){
            if(wf[i].nik == this.approvalUser.nik && !this.isCurrentApprover()){
                status=wf[i].status;
                break;
            }
        }
        return status;
    },
    getApproveDate(wf){
        let approvedWf = null;
        for(let i=0;i<wf.length;i++){
            if(wf[i].nik == this.approvalUser.nik){
                approvedWf=wf[i];
                break;
            }
        }
        return approvedWf.date;
    },
    isCurrentApprover(){
        if (this.ip.ipStatus == 2) {
            for (const wf of this.ip.ipWorkflow) {
                if (this.$store.getters.isAuthenticated) {
                    if ((wf.status == 9) && (wf.approverId == this.dataUsers.nik)) {
                        return true;
                    }
                }
            }
        }
        return false
    },
    approvalTime(date){
        return new Date(date).toLocaleString('en-GB');
    }
  },
  watch: {
    // approvalDialog2 (val) {
    //     if (!val) return
    //     let formData = new FormData();
    //     formData.append('_id', this.ip._id);
    //     formData.append('status', parseInt(this.approval));
    //     formData.append('comment', this.comment);
    //     formData.append('approvalUser', JSON.stringify(this.approvalUser));
        
    //     formData.append('formCode', this.ip.ipForm);
    //     const config = {
    //         method: "put",
    //         url: `${this.API_URL}/v1/requests/approvalAttachment`,
    //         headers: {"Authorization": `Bearer ${this.$store.state.token}`},
    //         data: formData
    //     };
    //     axios(config).then(res => {
    //         if (res.status == 200) {
    //             setTimeout(() => {
    //                 this.dialog2 = false;
    //                 this.dialog = false;
    //                 location.reload();
    //             },
    //             1000);
    //         }
    //     });
     
    // }
    
  }
};
</script>
<style scoped>
.ck-editor__editable {
    min-height: 200px !important;
    max-height: 600px !important;
}
.print-bg {
  background: rgb(204,204,204);
  padding-top: 10px;
}
.print-bg > div{
  text-align:center;
}
.page {
  background: white;
  display: block;
  margin: 5px auto;
  padding: 0.7cm 1cm 0.8cm;
  position: relative;
}
.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}
.page[size="Auto"] {
  width: auto;
  margin:0 auto;
  display:inline-block;
  text-align:initial;
}
.view-width {
  width: 19cm;
}
.print-header {
  border-collapse: collapse;
  text-align: right;
}
.padding-x-3 {
  padding:0 3px;
}
.padding-xy-5 {
  padding:2px;
}
.padding-xy-1 {
  padding:1px;
}
.margin-tl-5 {
  margin: 3px 5px 0 5px;
}
.margin-tl-10 {
  margin: 3px 10px 0 10px;
}
.margin-tl-25 {
  margin: 3px 15px 0 25px;
}
.logo-cell {
  padding:8px 5px 0px;
  width:35%;
}
.detail-wrap {
  margin-top: 5px;
}
.border-left-0 {
  border-left: 0;
}
.border-right-0 {
  border-right: 0;
}
.approved {
  text-align: center;
  padding:5px;
}
.ff0000 {
  color: #ff0000;
}
.align-center {
  text-align: center;
}
.align-left {
 align-items: left;
}
.width-20p {
  width:20%;
}
.width-25p {
  width:25%;
}
.height-40px {
  height: 40px;
}
.width-300px {
  width: 250px;
}
.top-align {
  vertical-align:top;
}
.navFixed {
  position: fixed;
  z-index: 9;
}
.padTop60 {
  padding-top:60px;
}
.blink {
	-webkit-animation: blink 2s steps(5, start) infinite;
  animation: blink 2s steps(5, start) infinite;
  color: #dddddd;
}
@-webkit-keyframes blink { to { color: #ffffff; }}
@keyframes blink { to { color: #ffffff; }}
@media print {
    
}
table {
  border-collapse: collapse;
}
.headerTable{
    border: 1px solid black; 
    background-color: #cccccc;
    font-weight: 600;
}
.tableInput td{
    border: 1px solid black;
    padding-left: 5px;
}
.verMiddle{
    vertical-align:middle;
}
.comment{
    word-break: break-all;
}
.tableCollapse td{
    border: 1px solid black;
    border-top: 0;
    padding-left: 5px;
}
.emptySign {
    text-align: center;
    padding: 5px;
}
#background {
  position:absolute;
  z-index:0;
  /* display:block; */
  top:150px;
  left:0px;
  text-align: center;
  width: 100%;
}
.imgWatermark {
  width: 650px;
  position:absolute;
  top:0px;
  right:50px;
  opacity: 0.65;
}
.fontWatermarkUp {
  font-size:450%; 
  position:absolute;
  transform: rotate(-30deg);
  opacity: 0.65;  
  right: 200px;
  color: rgb(224,224,224);
}
.fontWatermarkDown {
  font-size:450%; 
  position:absolute;
  transform: rotate(-30deg);
  opacity: 0.65;  
  top: 450px;
  right: 100px;
  color: rgb(224,224,224);
}
</style>